export default "__VITE_ASSET__CoKs2YGc__"